export const VIEW_SHARE_ACTION_TYPES = {
    SET_FILTERS_SELECTED: 'base/view-share/SET_FILTERS_SELECTED',
    SET_TREND_FILTER_FREQUENCY: 'base/view-share/SET_TREND_FILTER_FREQUENCY',
    SET_TREND_FILTER_COMPARE: 'base/view-share/trend/SET_TREND_FILTER_COMPARE',

    CLEAR_FILTERS: 'base/view-share/CLEAR_FILTERS_SELECTED'
};
